import { TFunction } from 'i18next'
import {
  dateToSlashString,
  dateToSlashStringReinterpretedAsLocal,
} from '../../../../utils/dateUtility'
import getLocaleCurrencyForAmount from '../../../../utils/getLocaleCurrencyForAmount'
import { Payment } from '../../../Interfaces/Payment'

export const getLcdLicensingPaymentHistoryRows = (
  t: TFunction,
  paymentHistory: Payment[]
): Payment[] => {
  const rows: Payment[] = paymentHistory.map((payment) => {
    return {
      ...payment,
      date: dateToSlashString(payment.begunAt, true),
      program: `${payment.licensingPayment?.programType ?? ''} (${
        payment.licensingPayment?.semesterOneStartDate
          ? dateToSlashStringReinterpretedAsLocal(
              payment.licensingPayment?.semesterOneStartDate as Date
            )
          : ''
      })`,
      paymentAmount: getLocaleCurrencyForAmount(
        payment?.licensingPayment?.amount?.amount ?? '0.00',
        payment.licensingPayment?.amount?.currencyCode ?? 'USD'
      ),
      communityName: payment.licensingPayment?.communityName,
      communityId: payment.licensingPayment?.communityKey,
      acumaticaOrderNumber: payment.orderId,
      canUserEdit:
        payment.licensingPayment?.paymentInformation?.canUserEdit ?? false,
    }
  })

  return rows
}
